import { QueryKeys } from "@/constants/Query";
import { useApiMutation } from "@/hooks/useApiMutation";
import axiosInstance from "@/lib/axios";
import { useQueryClient } from "@tanstack/react-query";
import { useParams } from "@tanstack/react-router";
import type * as fhirTypes from "fhir/r4";

interface CreateFollowUpParams {
  followupMessage: string;
  followupDurationValue: number;
  followupDurationUnit: string;
}

interface CreateFollowUpResponse {
  carePlan: fhirTypes.CarePlan;
  followupDurationUnit: string | null;
  followupDurationValue: number | null;
  followupMessage: string | null;
}

export const useCreateFollowUp = ({
  childEncounterId,
  carePlanId,
}: {
  childEncounterId: string;
  carePlanId: string;
}) => {
  const queryClient = useQueryClient();
  const { patientId } = useParams({ from: "/patient/$patientId" });
  return useApiMutation<CreateFollowUpResponse, CreateFollowUpParams>({
    mutationOptions: {
      mutationKey:
        QueryKeys.Patient.Chart.EpisodesOfCare.CarePlan.FollowUp.CREATE({
          patientId,
          childEncounterId,
          carePlanId,
        }),
      mutationFn: (params) => {
        return axiosInstance.post(
          `/charting/careplan/${carePlanId}/followup`,
          params,
        );
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey:
            QueryKeys.Patient.Chart.EpisodesOfCare.CarePlan.FollowUp.DEFAULT({
              patientId,
              childEncounterId,
              carePlanId,
            }),
        });
        queryClient.invalidateQueries({
          queryKey: QueryKeys.Patient.Chart.EpisodesOfCare.CarePlan.SUMMARY({
            patientId,
            encounterId: childEncounterId,
          }),
        });
      },
    },
  });
};
